<template>
  <div class="privacy-container">
    <div class="privacy-content">
      <h1>{{ $t('privacy.title') }}</h1>
      <div class="privacy-section">
        <h2>{{ $t('privacy.sections.collection.title') }}</h2>
        <p>{{ $t('privacy.sections.collection.content') }}</p>
      </div>
      <div class="privacy-section">
        <h2>{{ $t('privacy.sections.usage.title') }}</h2>
        <p>{{ $t('privacy.sections.usage.content') }}</p>
      </div>
      <div class="privacy-section">
        <h2>{{ $t('privacy.sections.sharing.title') }}</h2>
        <p>{{ $t('privacy.sections.sharing.content') }}</p>
      </div>
      <div class="privacy-section">
        <h2>{{ $t('privacy.sections.security.title') }}</h2>
        <p>{{ $t('privacy.sections.security.content') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerPrivacy'
}
</script>

<style scoped>
.privacy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.privacy-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.privacy-section {
  margin-bottom: 2rem;
}

h1 {
  color: #333;
  margin-bottom: 2rem;
  text-align: center;
}

h2 {
  color: #444;
  margin-bottom: 1rem;
}

p {
  color: #666;
  line-height: 1.6;
}
</style> 